import { LABEL_MAX_LENGTH } from '@shared/constants/textLimits';

/**
 * A name prefix/suffix fits the Label tier. Counts UTF-16 units, like the field's native `maxLength`
 * and contact_service's cap. Empty values pass here — required-ness is a separate rule.
 */
export const isNameAffixWithinLimit = (value: string | undefined): boolean => !value || value.length <= LABEL_MAX_LENGTH;
